import { Alert, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSupplierContactNamePolicy } from '~/modules/NegotiationSupplierContactWidget/hooks/useSupplierContactNamePolicy';

import { resolveContactNameHint } from './SupplierContactNameHint.utils';

interface SupplierContactNameHintProps {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
}

export const SupplierContactNameHint = ({ firstName, lastName }: SupplierContactNameHintProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SupplierContactForm.contact.nameHint' });
  const policy = useSupplierContactNamePolicy();
  const hint = resolveContactNameHint(policy, firstName, lastName);

  if (!hint) return null;

  return (
    <Grid size={12}>
      <Alert severity={hint.severity} data-testid="supplier-contact-name-hint">
        {t(hint.key, { name: hint.name })}
      </Alert>
    </Grid>
  );
};
